import { getDaysInMonth, getMonth, getYear } from "date-fns";

export const currentYear = new Date().getFullYear();

export const validateFormattedStringAsDate = (date: string): boolean => {
  const [day, month, year] = date.split(".").map(item => Number(item));
  const yearRange = [1800, getYear(new Date())];
  const dateFromValue = new Date(`${year}/${month}/${day}`);

  const daysInMonth = getDaysInMonth(new Date(year, month - 1));

  const isDayValid = day <= daysInMonth;
  // need to reduce month value by 1 to accommodate new Date formats the month
  // ex. when given Jan as 'month' you will get 0
  const isMonthValid = getMonth(dateFromValue) === month - 1;

  const isYearValid = year >= yearRange[0] && year <= yearRange[1];

  return isDayValid && isMonthValid && isYearValid;
};
